import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useNotification } from "../context/NotificationContext";
import { useClient } from "../context/ClientContext";

const VerifyEmailAddressToken = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const client = useClient("AUTH_SERVICE");
  const notification = useNotification();

  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        notification.error("Invalid token.");
        navigate("/login");
        return;
      }
      try {
        const response = await client.post("/auth/verify-email", { token });

        if (response?.message?.toLowerCase().includes("invalid token")) {
           notification.error("Token is invalid or expired.");
           navigate("/login");
        } else if (response?.message?.toLowerCase().includes("verified successfully")) {
           notification.success("Email verification was successfully");
           navigate("/login");
        }
        
      } catch (err: any) {
        notification.error(err.message || "Error verifying token.");
        navigate("/login");
      }
    };
    verifyToken();
  }, [token, client, notification, navigate]);

  return null; 
};

export default VerifyEmailAddressToken;
